import { memo } from "react";

/**
 * Official STRATIQ Logo — Uses the official uploaded image asset.
 *
 * @param {number} height - Desired height in px. Width scales proportionally.
 * @param {string} className - Additional classes
 */
const StratiqLogo = memo(function StratiqLogo({
  height = 185,
  className = "",
}) {
  return (
    <img
      data-testid="stratiq-logo"
      src="/stratiq_official_logo_cropped.png"
      alt="STRATIQ"
      className={className}
      style={{ height: `${height}px`, width: "auto" }}
    />
  );
});

export default StratiqLogo;
